import SharesTable from './SharesTable';
export default SharesTable;